// extracted by mini-css-extract-plugin
export default {"visibility-hidden":"_visibility-hidden_ny4pzB"};